import React, { useState, useEffect } from "react";
import CardItem from "./CardItem";
import api from "../../Utils/api";

// Card item component

// Section wrapper
function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-bold text-slate-700 mb-3">{title}</h2>
      {children}
    </div>
  );
}

export default function DashboardCards({
  setUserId,
  openDialog,

  openShifts,
  shiftSwaps,
  shiftOffers,
  leaveRequests,
  unavailables,

  lateShifts,
  todayLeaves,
}) {
  // Map server response keys to card data dynamically using dashboardData
  const cardDataMap = {
    open: {
      color: "bg-pink-400",
      title: "Open Shifts",
      subtitle: `${openShifts.length} open shift${
        openShifts.length !== 1 ? "s" : ""
      } to fill`,
      icon: <i className="fa-regular fa-calendar-plus text-pink-400 mr-1" />,
      data: openShifts,
    },
    shift_offer: {
      color: "bg-teal-400",
      title: "Shift Offers",
      subtitle: `${shiftOffers.length} shift offer${
        shiftOffers.length !== 1 ? "s" : ""
      } pending`,
      icon: <i className="fa-solid fa-handshake text-teal-400 mr-1" />,
      data: shiftOffers,
    },
    unavailable: {
      color: "bg-purple-400",
      title: "Unavailability",
      subtitle: `${unavailables.length} unavailability${
        unavailables.length !== 1 ? "ies" : ""
      } this week`,
      icon: <i className="fa-solid fa-user-slash text-purple-400 mr-1" />,
      data: unavailables,
    },
    leave: {
      color: "bg-green-400",
      title: "Leave Requests",
      subtitle: `${leaveRequests.length} leave request${
        leaveRequests.length !== 1 ? "s" : ""
      } pending`,
      icon: <i className="fa-solid fa-plane-departure text-green-400 mr-1" />,
      data: leaveRequests,
    },
    shift_swap: {
      color: "bg-blue-400",
      title: "Shift Swaps",
      subtitle: `${shiftSwaps.length} shift swap${
        shiftSwaps.length !== 1 ? "s" : ""
      } needs action`,
      icon: <i className="fa-solid fa-retweet text-blue-400 mr-1" />,
      data: shiftSwaps,
    },
  };

  function NeedsAttentionSection() {
    const needsAttentionKeys = ["open", "unavailable"];

    return (
      <Section title="Needs Attention">
        {needsAttentionKeys.map((key) => {
          const card = cardDataMap[key];
          return (
            <CardItem
              openDialog={openDialog}
              setUserId={setUserId}
              key={key}
              color={card.color}
              title={card.title}
              subtitle={card.subtitle}
              icon={card.icon}
              data={card.data}
            />
          );
        })}
      </Section>
    );
  }

  function NeedsApprovalSection() {
    const needsApprovalKeys = ["shift_swap", "leave", "shift_offer"];

    return (
      <Section title="Needs Approval">
        {needsApprovalKeys.map((key) => {
          const card = cardDataMap[key];
          return (
            <CardItem
              openDialog={openDialog}
              setUserId={setUserId}
              key={key}
              color={card.color}
              title={card.title}
              subtitle={card.subtitle}
              icon={card.icon}
              data={card.data}
            />
          );
        })}
      </Section>
    );
  }

  return (
    <div className="grid grid-cols-1 min-h-[30vh] md:grid-cols-3 gap-8 mb-10">
      <NeedsAttentionSection />
      <NeedsApprovalSection />
      <Section title="What's happening?">
        <CardItem
          color="bg-orange-400"
          title="Running Late"
          subtitle={`${lateShifts.length} team members late`}
          icon={<i className="fa-solid fa-clock text-orange-400 mr-1" />}
          data={lateShifts}
        />
        <CardItem
          color="bg-teal-400"
          title="People on Leave"
          subtitle={`${todayLeaves.length} person on leave today`}
          icon={<i className="fa-solid fa-user-clock text-teal-400 mr-1" />}
          data={todayLeaves}
        />
      </Section>
    </div>
  );
}
